import { render, staticRenderFns } from "./StatusForm.vue?vue&type=template&id=64302414"
import script from "./StatusForm.vue?vue&type=script&lang=js"
export * from "./StatusForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports